export interface EmailCampaignInputItemsProps {
  name: string;
  emailCampaignId: string;
  preheader: string;
  subject: string;
  linkOnDesign: string;
  textContent: string;
  hasPosterId: boolean;
  isAiContentGenerationEnabled: boolean;
  isEmailTextContentEmpty: boolean;
  autoAiGenerationActive: boolean;
  templateTextContent: string;
  onEmailSubjectChanged: (val: string) => void;
  onEmailPreheaderChanged: (val: string) => void;
  onEmailTextContentChanged: (val: string) => void;
  onEmailLinkOnDesignChanged: (val: string) => void;
  updateProgressBarWithFilledFields: (totalRquiredInputFields: number, filledRquiredInputFields: number) => void;
}

export enum EmailCampaignInputItemTypes {
  NAME = 'name',
  SUBJECT = 'subject',
  PREHEADER = 'preheader',
  TEXT_CONTENT = 'textContent',
  LINK_ON_DESIGN = 'linkOnDesign',
}

export const EMAIL_CAMPAIGN_INPUT_ITEMS_REQUIRED_FIELDS = [EmailCampaignInputItemTypes.NAME, EmailCampaignInputItemTypes.SUBJECT];
